import { render, staticRenderFns } from "./DicomViewer.vue?vue&type=template&id=55a74ded&scoped=true"
import script from "./DicomViewer.vue?vue&type=script&lang=js"
export * from "./DicomViewer.vue?vue&type=script&lang=js"
import style0 from "./DicomViewer.vue?vue&type=style&index=0&id=55a74ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a74ded",
  null
  
)

export default component.exports